import { render, staticRenderFns } from "./UnderwearIcon.vue?vue&type=template&id=7a177107&"
import script from "./UnderwearIcon.vue?vue&type=script&lang=js&"
export * from "./UnderwearIcon.vue?vue&type=script&lang=js&"
import style0 from "./UnderwearIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports